export default "__VITE_ASSET__u_3txfbt__"